// extracted by mini-css-extract-plugin
export var locationCard = "_ej-0";